import React, { useState } from 'react';
import { Link, Linkedin, ArrowRight } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

const Footer = ({ footer }) => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email) return;

    toast({
      title: 'Subscribed!',
      description: `Thanks for subscribing with ${email}`,
    });

    setEmail('');
  };

  return (
    <footer className="pt-10 pb-6">

      {/* Footer columns */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

        {/* Stay Updated */}
        <div className="border-b md:border-b-0 md:border-r divider-line pb-8 md:pb-0 md:pr-6">
          <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui font-medium text-[#0f0f0f]">
            {footer.stay.label}
          </p>

          <p className="font-serif-body text-[15px] text-[#2a2a2a] mt-3 leading-snug whitespace-pre-line">
            {footer.stay.body}
          </p>

          <form
            onSubmit={handleSubscribe}
            className="mt-4 flex flex-col sm:flex-row"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your Email Address"
              className="w-full sm:flex-1 min-w-0 bg-transparent border border-[#1a1a1a] px-3 py-2.5 text-[12px] font-sans-ui text-[#1a1a1a] placeholder:text-[#7a7568] focus:outline-none"
            />

            <button
              type="submit"
              className="newspaper-btn mt-2 sm:mt-0 bg-[#1a1a1a] text-[#f0ebe0] px-4 py-2.5 text-[10px] tracking-[0.25em] font-sans-ui hover:bg-[#8b2331]"
            >
              SUBSCRIBE
            </button>
          </form>
        </div>

        {/* Let's Work Together */}
        <div
          id="contact"
          className="border-b md:border-b-0 md:border-r divider-line pb-8 md:pb-0 md:pr-6"
        >
          <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui font-medium text-[#0f0f0f]">
            {footer.work.label}
          </p>

          <p className="font-serif-body text-[15px] text-[#2a2a2a] mt-3 leading-snug whitespace-pre-line">
            {footer.work.body}
          </p>

          <Link
            to="/contact"
            onClick={() =>
              window.scrollTo({
                top: 0,
                behavior: 'auto',
              })
            }
            className="newspaper-btn mt-4 inline-flex items-center gap-3 border border-[#1a1a1a] text-[#1a1a1a] px-4 py-2.5 text-[10px] tracking-[0.25em] font-sans-ui hover:bg-[#1a1a1a] hover:text-[#f0ebe0]"
          >
            {footer.work.cta}
            <ArrowRight size={13} />
          </Link>
        </div>

        {/* Follow Me */}
        <div className="pb-2">
          <p className="text-[10px] sm:text-[11px] tracking-[0.25em] sm:tracking-[0.28em] font-sans-ui font-medium text-[#0f0f0f]">
            FOLLOW ME
          </p>

          <div className="mt-4 flex flex-wrap items-center gap-3">

            {/* LinkedIn */}
            <a
              href="https://www.linkedin.com/in/shraviranade-graphicdesigner/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="w-9 h-9 flex shrink-0 items-center justify-center bg-[#1a1a1a] text-[#f0ebe0] hover:bg-[#8b2331] transition-colors"
            >
              <Linkedin size={18} />
            </a>

          </div>
        </div>

      </div>

      {/* Copyright */}
      <div className="border-t divider-line mt-8 pt-4">
        <p className="text-[10px] sm:text-[11px] font-serif-body italic text-[#2a2a2a] text-center sm:text-right">
          {footer.copyright}
        </p>
      </div>

    </footer>
  );
};

export default Footer;